<template>
    <div id="loading-widget">

      <v-overlay :value="statusLoading" style="z-index: 99999999 !important;">
        <v-progress-circular  indeterminate size="64"></v-progress-circular>
      </v-overlay>

    </div>
</template>

<script>
    export default {
      name: "LoadingScreen",
      data() {
        return {


        }
      },
      props: {
        statusLoading: {
          type: Boolean
        }
      },
      methods:{


      }

    }
</script>

<style>

</style>